/**
 * Ticket Notification Manager
 * Self-contained, Redux-independent notification system.
 * Uses a custom DOM event bus so it works from thunks, services, or components.
 */

export type TicketNotifPayload = {
    title: string;
    body: string;
    ticketType?: string;
    ticketId?: number | string;
    priority?: string;
};

const EVENT_NAME = 'fv:ticket-notification';

/** Fire a notification from ANYWHERE (thunk, service, component) */
export const fireTicketNotification = (payload: TicketNotifPayload) => {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
};

/** Subscribe to ticket notifications (call in a React useEffect) */
export const onTicketNotification = (
    cb: (payload: TicketNotifPayload) => void
): (() => void) => {
    const handler = (e: Event) => cb((e as CustomEvent).detail);
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
};
